import { render, staticRenderFns } from "./Chapter8_5.vue?vue&type=template&id=21aecdde&scoped=true&"
import script from "./Chapter8_5.vue?vue&type=script&lang=js&"
export * from "./Chapter8_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aecdde",
  null
  
)

export default component.exports